import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center bg-background"
      >
        <Loader2 className="animate-spin text-primary" size={28} />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};
